const operationsName = [
    {
      value: 'create[/actions]',
      label: 'create[/actions]'
    },
    {
      value: 'add_message[/actions]',
      label: 'add_message[/actions]'
    },
    {
      value: 'update[/actions]',
      label: 'update[/actions]'
    },
    {
      value: 'create[/areas]',
      label: 'create[/areas]'
    },
    {
      value: 'update[/areas]',
      label: 'update[/areas]'
    },
    {
      value: 'soft_delete[/areas]',
      label: 'soft_delete[/areas]'
    },
    {
      value: 'create[/backupsrealm]',
      label: 'create[/backupsrealm]'
    },{
      value: 'update[/backupsrealm]',
      label: 'update[/backupsrealm]'
    },
    {
      value: 'create[/companies]',
      label: 'create[/companies]'
    },
    {
      value: 'update[/companies]',
      label: 'update[/companies]'
    },
    {
      value: 'soft_delete[/companies]',
      label: 'soft_delete[/companies]'
    },
    {
        value: 'create[/equipmentgroups]',
        label: 'create[/equipmentgroups]'
    },
    {
        value: 'update[/equipmentgroups]',
        label: 'update[/equipmentgroups]'
    },
    {
        value: 'soft_delete[/equipmentgroups]',
        label: 'soft_delete[/equipmentgroups]'
    },
    {
        value: 'create[/equipmentmodels]',
        label: 'create[/equipmentmodels]'
    },
    {
        value: 'update[/equipmentmodels]',
        label: 'update[/equipmentmodels]'
    },
    {
        value: 'add_equipment_service[/equipmentmodels]',
        label: 'add_equipment_service[/equipmentmodels]'
    },
    {
        value: 'remove_equipment_service[/equipmentmodels]',
        label: 'remove_equipment_service[/equipmentmodels]'
    },
    {
        value: 'clone[/equipmentmodels]',
        label: 'clone[/equipmentmodels]'
    },
    {
        value: 'cloneChecklist[/equipmentmodels]',
        label: 'cloneChecklist[/equipmentmodels]'
    },
    {
        value: 'cloneChecklistBySite[/equipmentmodels]',
        label: 'cloneChecklistBySite[/equipmentmodels]'
    },
    {
        value: 'soft_delete[/equipmentmodels]',
        label: 'soft_delete[/equipmentmodels]'
    },
    {
        value: 'create[/equipments]',
        label: 'create[/equipments]'
    },
    {
        value: 'update[/equipments]',
        label: 'update[/equipments]'
    },
    {
        value: 'soft_delete[/equipments]',
        label: 'soft_delete[/equipments]'
    },
    {
        value: 'batch_inactivate[/equipments]',
        label: 'batch_inactivate[/equipments]'
    },
    {
        value: 'add_document[/equipments]',
        label: 'add_document[/equipments]'
    },
    {
        value: 'revert_delete[/equipments]',
        label: 'revert_delete[/equipments]'
    },
    {
        value: 'create[/equipmentservices]',
        label: 'create[/equipmentservices]'
    },
    {
        value: 'update[/equipmentservices]',
        label: 'update[/equipmentservices]'
    },
    {
        value: 'soft_delete[/equipmentservices]',
        label: 'soft_delete[/equipmentservices]'
    },
    {
        value: 'delete_checklist_by_site[/equipmentservices]',
        label: 'delete_checklist_by_site[/equipmentservices]'
    },
    {
        value: 'create[/files]',
        label: 'create[/files]'
    },
    {
        value: 'hard_delete[/files]',
        label: 'hard_delete[/files]'
    },
    {
        value: 'create[/frequency]',
        label: 'create[/frequency]'
    },
    {
        value: 'update[/frequency]',
        label: 'update[/frequency]'
    },
    {
        value: 'soft_delete[/frequency]',
        label: 'soft_delete[/frequency]'
    },
    {
        value:  'create[/maintenances]',
        label:  'create[/maintenances]'
    },
    {
        value: 'update[/maintenances]',
        label: 'update[/maintenances]'
    },
    {
        value: 'soft_delete[/maintenances]',
        label: 'soft_delete[/maintenances]'
    },
    {
        value: 'add_message[/maintenances]',
        label: 'add_message[/maintenances]'
    },
    {
        value: 'create[/photos]',
        label: 'create[/photos]'
    },
    {
        value: 'hard_delete[/photos]',
        label: 'hard_delete[/photos]'
    },
    {
        value: 'create[/places]',
        label: 'create[/places]'
    },
    {
        value: 'update[/places]',
        label: 'update[/places]'
    },
    {
        value: 'soft_delete[/places]',
        label: 'soft_delete[/places]'
    },
    {
        value: 'copy_paste[/places]',
        label: 'copy_paste[/places]'
    },
    {
        value: 'create[/questions]',
        label: 'create[/questions]'
    },
    {
        value: 'update[/questions]',
        label: 'update[/questions]'
    },
    {
        value: 'soft_delete[/questions]',
        label: 'soft_delete[/questions]'
    },
    {
        value: 'create[/quicksight]',
        label: 'create[/quicksight]'
    },
    {
        value: 'update[/quicksight]',
        label: 'update[/quicksight]'
    },
    {
        value: 'destroy[/quicksight]',
        label: 'destroy[/quicksight]'
    },
    {
        value: 'create[/services]',
        label: 'create[/services]'
    },
    {
        value: 'update[/services]',
        label: 'update[/services]'
    },
    {
        value: 'soft_delete[/services]',
        label: 'soft_delete[/services]'
    },
    {
        value: 'create[/servicetypes]',
        label: 'create[/servicetypes]'
    },
    {
        value: 'update[/servicetypes]',
        label: 'update[/servicetypes]'
    },
    {
        value: 'soft_delete[/servicetypes]',
        label: 'soft_delete[/servicetypes]'
    },
    {
        value: 'create[/sites]',
        label: 'create[/sites]'
    },
    {
        value: 'update[/sites]',
        label: 'update[/sites]'
    },
    {
        value: 'soft_delete[/sites]',
        label: 'soft_delete[/sites]'
    },
    {
        value: 'create[/supportfiles]',
        label: 'create[/supportfiles]'
    },
    {
        value: 'update[/supportFiles]',
        label: 'update[/supportFiles]'
    },
    {
        value: 'soft_delete[/supportFiles]',
        label: 'soft_delete[/supportFiles]'
    },
    {
        value: 'create[/tenants]',
        label: 'create[/tenants]'
    },
    {
        value: 'update[/tenants]',
        label: 'update[/tenants]'
    },
    {
        value: 'update_superadmin[/tenants]',
        label: 'update_superadmin[/tenants]'
    },
    {
        value: 'soft_delete[/tenants]',
        label: 'soft_delete[/tenants]'
    },
    {
        value: 'create_featureflag[/tenants]',
        label: 'create_featureflag[/tenants]'
    },
    {
        value: 'update_featureflag[/tenants]',
        label: 'update_featureflag[/tenants]'
    },
    {
        value: 'delete_featureflag[/tenants]',
        label: 'delete_featureflag[/tenants]'
    },
    {
        value: 'update_access[/users]',
        label: 'update_access[/users]'
    },
    {
        value: 'update_access_by_superadmin[/users]',
        label: 'update_access_by_superadmin[/users]'
    },
    {
        value: 'create[/users]',
        label: 'create[/users]'
    },
    {
        value: 'add_tenant_and_role[/users]',
        label: 'add_tenant_and_role[/users]'
    },
    {
        value: 'remove_tenant[/users]',
        label: 'remove_tenant[/users]'
    },
    {
        value: 'user_delete[/users]',
        label: 'user_delete[/users]'
    },
    {
        value: 'showMe[/users]',
        label: 'showMe[/users]'
    },
    {
        value: 'invite_signup[/users]',
        label: 'invite_signup[/users]'
    },
    {
        value: 'invite_signup_by_superadmin[/users]',
        label: 'invite_signup_by_superadmin[/users]'
    },
    {
        value: 'invite_create_user[/users]',
        label: 'invite_create_user[/users]'
    },
    {
        value: 'forgot_password[/users]',
        label: 'forgot_password[/users]'
    },
    {
        value: 'forgot_password_activate[/users]',
        label: 'forgot_password_activate[/users]'
    },
    {
        value: 'invite_add_tenant[/users]',
        label: 'invite_add_tenant[/users]'
    },
    {
        value: 'change_password[/users]',
        label: 'change_password[/users]'
    },
    {
        value: 'change_name[/users]',
        label: 'change_name[/users]'
    },
    {
        value: 'change_receive_automatic_emails[/users]',
        label: 'change_receive_automatic_emails[/users]'
    },
    {
        value: 'change_show_service_coordinates[/users]',
        label: 'change_show_service_coordinates[/users]'
    },
    {
        value: 'change_picture[/users]',
        label: 'change_picture[/users]'
    },
    {
        value: 'remove_access[/users]',
        label: 'remove_access[/users]'
    },
    {
        value: 'updateRealmId[/users]',
        label: 'updateRealmId[/users]'
    },
  ];

export default operationsName
